import type { ReactNode } from 'react';
import { useState } from 'react';

import * as S from './style';

type RulesArticle = {
	body: ReactNode;
	isBox?: boolean;
	title: string;
};

type RulesChapter = {
	articles: RulesArticle[];
	isNumbered?: boolean;
	title: string;
};

const submissionRules: ReactNode[] = [
	<>본 규정은 본 학회 정관 제4조에 의거하여 발간되는 학술지인 대한화장품학회지의 투고에 관한 제반 사항을 규정함을 목적으로 한다.</>,
	<>
		본 학회지에 투고하는 저자들은 논문의 심사와 발간이 신속하고 효율적으로 진행되게 하기 위하여 아래 규정사항을 따라야 한다. 만일 투고된 논문이 규정에 위배될
		경우 투고자에게 반송된다.
	</>,
	<>
		논문의 투고, 접수 및 채택
		<br />
		(1) 논문의 투고는 제1저자(주저자) 또는 교신저자가 대한화장품학회 홈페이지(www.scsk.or.kr)에 로그인한 후 본 학회의 온라인 논문투고 시스템에 투고자 정보를
		입력하고 심사용 논문파일을 업로드 한다. 다만, 시스템 상에 문제가 있을 경우 편집위원회의 이메일(scsk1968@naver.com)로 제출할 수 있다.
		<br />
		(2) 심사용 논문은 Hwp 또는 Word 파일로 작성하고 파일명은 저자이름과 소속기관을 기재하지 않고 논문제목으로 함을 원칙으로 한다.
		<br />
		(3) 논문이 접수되면 일련번호를 부여하고, 논문 접수 상황 및 기타 심사진행상황을 e-mail로 송부한다.
		<br />
		(4) 논문의 채택 여부는 본 학회지의 심사규정에 따라 결정한다. 다만, 투고된 논문이 투고 규정에 맞지 않을 경우 편집위원장은 재투고를 요구하거나 게재불가 처리를
		할 수 있다.
		<br />
		(5) 논문의 투고 및 심사와 관련한 제반 내용의 질의는 편집위원장 또는 학회 사무국에게 문의할 수 있다.
	</>,
	<>
		논문은 본 학술지에 투고하기 전에 다른 학술잡지에 발표 또는 투고 중이 아닌 것이어야 한다. 논문이 채택된 후에는 본 학술지의 서면 동의 없이 유사한 형식으로
		한글이나 다른 언어로 출판되어서는 안 된다.
	</>,
	<>논문의 투고는 본 학회의 회원에 한한다.</>,
	<>논문의 투고일자는 논문이 본 학회에 도착한 날을 “접수일”로 하고 최종심사 종료일을 “채택일”로 한다.</>,
	<>
		논문의 원고는 Hwp 또는 Word 파일로 제출하며, 게재가 결정된 논문의 최종본은 [대한화장품학회지 투고 및 원고작성 기준]에 의해 작성하고 이를 편집위원회에
		문서파일 형태로 송부하여야 한다. 제출된 논문은 저자에게 반환하지 않는다.
	</>,
	<>
		논문은 연구논문, 단신, 리뷰로 구분하여 아래규정에 준하여 투고할 수 있다.
		<br />
		(1) 연구 논문(research papers, article)은 새로운 실험 결과들이나 산업적인 응용에 대한 특별한 강조와 함께 새로운 해석들을 포함하는 내용을 포괄해야 한다.
		초록은 150∼200 단어로 제한된다.
		<br />
		(2) 단신(Short communications)은 빠른 보급을 보장하는 중요하거나 기술적인 정보를 포함한다. 독자들은 왜 그 기여가 빠른 발간이 되어야 하는지 문장 안에서
		규명해야 한다. 원고들은 보통 저널에 2∼3페이지를 차지하도록 계획된다. 초록은 150 단어로 제한한다.
		<br />
		(3) 리뷰(reviews)는 산업적이고 기술적인 화학의 제한된 분야 내에서 중요한 진보의 내용을 조사 및 제공한다.
	</>,
	<>
		모든 원고는 반드시 A4 용지에 충분한 간격을 두고 작성하며, 모든 페이지에 쪽번호를 기입한다.
		<br />
		(1) 논문 작성의 언어는 국어(한글) 또는 영어로 할 수 있으며, 국어의 경우 학술용어는 영어를 병용할 수 있다.
		<br />
		(2) 논문 작성을 국어로 할 경우 본문 문장 중의 영어의 사용은 가능한 한 억제하고 국어를 사용하되, 영어를 사용하여야 할 경우는 모두 소문자로 쓴다. 다만 문장을
		시작하는 곳에 영어 단어가 올 경우는 시작하는 첫 글자만 대문자로 한다.
		<br />
		(3) 논문내용 중 미생물명 등 학명과 “in situ”, “in vitro” 등 사전에서도 이탤릭체로 표기되는 단어는 이탤릭체로 표기한다. 또한 수식에 사용되는 알파벳 및 숫자도
		모두 이탤릭체로 하되 수식 중 자연로그를 나타내는 ln 및 첨자는 일반체로 한다.
	</>,
	<>
		원고는 다음 항목별로 새로운 면에서 시작하여야 한다.
		<br />
		(1) 제목, 저자명 및 연구기관은 국어 및 영어로 작성하며, 주저자는 † 위첨자로 표시를 하고 저자의 현 소속기관이 연구 당시와 다른 경우에는 현 소속기관도
		표시해야 한다. 교신저자는 †† 위첨자로 표시한다. 저자의 영문주소 표기 시 학과를 나타내는 약자로 쓰지 않고 “Department”와 같이 full text로 표기하여야 한다.
		단, 주저자와 교신전자 영문주소는 우편배달이 가능하도록 자세히 표기한다.
		<br />
		(2) 초록은 반드시 원고의 모든 내용을 제공하여야 한다. 초록은 목적, 범위, 방법, 중요한 결과, 결론을 한 문단 또는 단으로 서술한다. 국문 초록은 600자 이내,
		영문 초록은 200단어 이내 및 Keywords는 영문으로 5개 이내로 한다.
		<br />
		(3) 본문은 서론(Introduction), 실험방법(Experimental), 결과 및 고찰(Results and Discussion), 결론(Conclusion)과 같은 제목으로 나눈다.
		<br />
		(4) 감사의 말(Acknowledgment)
		<br />
		(5) 표(Table): 각각 다른 면
		<br />
		(6) 그림(Figure): 각각 다른 면, 그림 아래 캡션 작성
		<br />
		(7) References
	</>,
	<>
		표 위에 제목과 머리글이 있어야 한다. 표와 그래프는 중복이 되어선 안 된다. 그래프를 사용하는 경우에는 같은 데이터의 표가 있으면 안 된다. 모든 표는 A4 용지
		크기 (21 × 29.7 cm)에 명료하게 작성하고, 표 내의 긴 단어는 적당한 약어로 대치한 후 아래에 약어를 정의하여야 한다. 모든 표는 아라비아 숫자로 일련번호를
		부여하여야 한다. 예: Table 1
	</>,
	<>
		그림이나 사진은 저자가 스캔하여 저장한 파일로 제출한다. 모든 그림이나 사진은 크기가 1/2로 축소하여 인쇄된 후에도 명료하게 해독할 수 있도록 작성하며,
		아라비아 숫자로 일련번호를 부여하여야 한다. 예: Figure 1
	</>,
	<>
		모든 표와 그림의 제목 및 내용은 영어로 하여야 한다. 표의 제목은 상단에 위치시킨다. 표의 제목은 매 단어의 첫 글자를 대문자로 하되 관사와 전치사는 소문자로
		한다. 그림의 제목은 문장의 첫 글자만 대문자로 하고 제목이 끝나는 곳에 마침표를 찍는다.
	</>,
	<>
		본문, 그림 및 표에 사용된 약어, 시료명, 기호 등은 그것이 처음 사용된 곳에서 다음 예와 같은 형식으로 한 번만 정의해 주어야 한다. 예: polymethylmethacrylate
		(PMMA), lipoxygenase (Sigma, USA).
	</>,
	<>
		논문에서 사용된 약어, 기호 및 단위는 자체적으로 일관성이 있어야 한다. 명명법은 International Union of Pure and Applied Chemistry(IUPAC)과 Chemical Abstracts
		Service(CAS)을 준수한다. 모든 단위는 SI 단위의 사용을 원칙으로 한다. 특히 시간 단위의 초는 “s”, 분은 “min”, 시간은 “h”, 년은 “yr”로 각각 표기한다. 모든
		단위는 띄어 쓰는 것을 원칙으로 한다.
	</>,
	<>
		본문 중에 (), [] 등의 괄호가 나올 경우 괄호 앞이 국문인 경우는 붙여 쓰고 영문인 경우는 띄어 쓴다. 다만, “Figure 1A”, “A = 25” 등이 나올 경우는 기호 앞뒤로
		한 칸씩 띄어 쓴다.
	</>,
	<>
		수학적 표현과 화학식은 기호와 문자로 입력해야 한다. 대문자, 소문자와 그리스문자는 모호함을 방지하기 위해서 쉽게 식별되어야 한다. 수식은 연속적으로 아라비아
		숫자를 이용하여 번호가 매겨져야 하고 텍스트에 언급되어 있어야 한다. 예: Equation (2).
	</>,
	<>
		모든 참고문헌과 설명을 위한 메모가 있다면 그것은 내용에서 언급한 순서대로 쓰여야 하며, 해당 문구 내 알맞은 곳의 대괄호 속에 아라비아 숫자로 일련번호를
		부여하여야 한다. 인용된 참고문헌의 모든 저자들은 목록에 나타나져야 한다.
	</>,
	<>
		참고문헌이 학술잡지의 경우는 저자명, 논문명, 잡지명, 권(호)수, 첫 쪽수, 출판년도 순으로, 단행본이나 편집서인 경우는 저자명, 논문명, 편집자, 책명, 권수, 첫
		쪽수, 출판사명, 출판사소재지, 출판년도 순으로 명기하여야 하며, 권수는 두꺼운 글씨체로, 잡지명은 이탤릭체로 한다. 단, 없는 항목은 생략할 수 있으며 각
		참고문헌의 끝에는 마침표를 찍는다. 잡지명의 약기 방식은 Periodicals of International Standardization Organization(http://www.iso.org)에 따른다.
		<br />
		Original Paper: (1) J. W. Wiechers, C. L. Kelly, T. G. Blease, and J. C. Dederen, Formulating for efficacy, Int. J. Cosmet. Sci., 26(4), 173 (2004).
		<br />
		대한화장품학회지 영문표기: J. Soc. Cosmet. Sci. Korea
		<br />
		Book: (3) D. T. Downing and M. E. Steward, Epidermal composition, eds. M. London and H. I. Maibach, Dry skin and moisturizers, 13, CRC Press, Washington
		D.C. (2000).
		<br />
		Proceeding Book: (4) R. Haubner and K. Kopf, Proc. 3rd Intern. Symp. Surface Modification Tech., eds. T. S. Sudarshan and D. G. Bhat, 835, Neuchatel,
		Switzerland (1980).
		<br />
		Degree: (5) K. D. Hong, Ph. D. Dissertation, Seoul National Univ., Seoul, Korea (1989).
		<br />
		Patent: (6) U. S. Patent 4,121,025 (1978).
		<br />
		In-press DOI: (7) M. M. Ghaisas, S. B. Kshirsagar, and R. S. Sahane, Evaluation of wound healing activity of ferulic acid in diabetic rats, Int Wound J.,
		doi: 10.1111/j.1742-481X.2012.01119.x. (2012).
	</>,
	<>
		교정인쇄본, 논문 초본의 수정 복사, 그리고 별쇄본 요청 양식은 교신저자에게 편집자가 직접 전달하는 것을 원칙으로 한다. 별쇄본은 기본으로 10부를 무상으로
		제공하며, 저자가 추가 요구 시에는 1부당 1,000원을 납부하여야 한다.
	</>,
	<>
		연구 논문의 경우 최초 투고만 허용된다. 동일한 연구 내용이 다른 학술지에 출판되지 않아야 하며, 학회지의 출판을 위한 논문의 제출이 모든 저자들에게 인가된
		것이라는 것, 그리고 교신저자는 논문의 인용을 허가한다는 것을 전제하여 원고가 허용된다. 서면승인은 편집자의 결정에 의해 이루어진다. 대한화장품학회지에서
		출간된 논문들과 다른 출판물들은 저자(들)의 의견이 표현된다. 그리고 편집자(들)과 출판자의 의견을 반영해서는 안 된다. 저자 체크 리스트(author check list)와
		저작권 이양동의서(Copyright transfer)는 홈페이지와 이메일을 통해 제출하는 과정에서 확인할 수 있다.
	</>,
	<>
		논문 게재료는 편당 400,000원, 속보(급행)인 경우 1편당 600,000원으로 책정된다. 단, 기본 10페이지를 초과할 경우 페이지 당 40,000원씩 부과하며 추가로 납부해야
		한다. 편집위원장은 각 논문에 세 명 이상의 심사위원을 선정한다. 편집자는 이메일 주소를 포함한 저자 및 심사위원의 연락처 정보를 제공받도록 되어있다. 저자들은
		심사위원들이 누군지, 어떤 전문적인 지식을 가지고 있는지에 대해 편집자에게 요청할 수 없으며, 이는 심사위원들이 저자에게 편파 없는 충고를 하기 위함이다.
		참고문헌은 가능하면 저자가 속해있는 곳과 다른 곳에서 참고하도록 함을 원칙으로 한다.
	</>,
	<>
		모든 논문의 심사와 발행 과정은 비밀리에 진행된다. 편집인에 의해 선정된 3명 정도의 익명의 전문가들이 전문가평가(Peer-review)를 진행한다. 전문가 평가 후
		편집자에게 전달되는 심사평지에는 심사한 내용과 게재 가능 여부에 대한 결정이 포함된다. 교신저자는 논문이 ‘채택’, ‘수정 후 채택’, ‘수정 후 재심’, ‘채택불가’
		될 것인지에 대한 결정을 편집인으로부터 전달받는다. 마지막 개정 논문이 완전하게 대한화장품학회 형식과 기준에 맞추어 채택이 되게 되면 다음 이용가능한 권, 호에
		게재 예정 일정이 확정된다.
	</>,
	<>
		심사 과정에 있는 원고에 대하여 저자가 철회를 원하는 경우, 주저자(제1저자) 또는 교신저자는 편집위원장에게 e-mail로 철회요청서를 제출해야 한다. 이후 접수된
		논문은 온라인 투고 시스템에서 삭제 처리한다.
	</>,
	<>자세한 논문투고 규정은 대한화장품학회 자체평가서에 제시된 기준을 따른다.</>,
	<>
		사단법인 대한화장품학회는 교신저자에게 저작권 이양동의서에 다른 모든 저자들을 대표하여 서명할 것을 요구한다. 이 동의서 형식은 논문 초고가 접수되고 게재
		일정이 결정되면 교신저자에게 발송된다. 서명된 동의서 형식이 제출되기 전까지 학회는 논문을 게재하지 않는 것을 원칙으로 한다. 본 학회지에 게재되었거나 발표된
		논문의 저작권은 사단법인 대한화장품학회에 있다.
	</>,
	<>
		연구윤리: 저자는 다음의 조건들을 충족하는 사람으로 제한한다.
		<br />
		(1) 연구의 컨셉과 디자인 또는 습득, 해석 그리고 데이터 분석에 상당히 기여한 자
		<br />
		(2) 논문의 초고 작성 또는 실험 결과를 학술적으로 해석하여 수정한 자
		<br />
		(3) 출판을 위한 교정 인쇄본을 최종적으로 승인한 자
		<br />
		(4) 교신저자는 결과 해석에 영향을 줄 수 있는 가능한 모든 이해 사항, 즉 제약회사로부터의 재정 지원 또는 연관 관계, 이익집단의 정치적 압력, 학문적으로 관계된
		문제 등의 정보를 편집자에게 알려야 한다. 특히 연구에 사용된 모든 재정적 지원에 대해서는 명백하게 밝혀야 한다.
	</>,
	<>
		실험 진행에 있어서는 다음의 조건들이 충족되어야 한다.
		<br />
		(1) 인간 대상의 연구에서 절차는 저자의 연구소의 임상시험 심사위원회(IBR)와 1975년 헬싱키선언(2000년 개정)의 윤리적 기준을 따라야 한다.
		<br />
		(2) 동물 실험의 경우 저자는 실험실 동물의 보호와 사용을 위해 협회 또는 국제 가이드라인을 따라야 한다. 이 지침에 명시되지 않은 연구와 출판 윤리 정책의
		경우에는 편집자와 저자에 대한 국제 표준(http://publicationethics.org/international-standards-editors-and-authors)이 적용될 수 있다.
	</>,
	<>
		성(생물학적 요인)과 성 정체성(심리, 사회적 또는 문화적 요인)이라는 용어의 올바른 사용을 확인하고, 부적절한 경우가 아니라면 연구 참여자의 성별, 동물 또는
		세포의 성을 보고하고 성별을 결정하는 데 사용되는 방법을 기술해야 한다. 예를 들어 한쪽 성별과 같이 독점적인 집단이 포함된 연구가 수행된 경우 저자는 명백한
		경우(예: 전립선암)를 제외하고 이유를 정당화해야 한다. 저자는 인종 또는 민족을 어떻게 결정했는지 정의하고 관련성을 정당화해야 한다.
	</>,
	<>
		학회지 구독 정보: 본 학회지에 발표된 논문은 온라인 웹사이트(http://www.scsk.or.kr/)를 통해 구독이 가능하다. 기타 문의 사항은 대한화장품학회 사무국 (e-mail:
		scsk1968@naver.com, Tel: +82-2-6713-1968, Fax: +82-2-6713-1969)으로 문의가 가능하다.
	</>,
	<>
		부칙
		<br />이 규정은 2021년 3월 2일부터 시행한다.
		<br />이 규정은 2026년 2월 25일부터 시행한다.
	</>,
];

const charterChapters: RulesChapter[] = [
	{
		title: '총 칙',
		articles: [
			{
				title: '명칭',
				body: (
					<S.RulesDescription>
						본 법인은 사단법인 대한화장품학회(The Society of Cosmetic Scientists of Korea) (이하 “본 학회”라 한다)라 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '소재지',
				body: <S.RulesDescription>본 학회의 사무소는 서울특별시에 두며, 필요한 곳에 분사무소(지부)를 설치할 수 있다.</S.RulesDescription>,
			},
			{
				title: '목적',
				body: <S.RulesDescription>본 학회는 화장품 관련 학문의 발전과 대한민국의 화장품 산업 발달에 공헌함을 목적으로 한다.</S.RulesDescription>,
			},
			{
				title: '사업',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>본 학회는 제3조의 목적을 달성하기 위하여 다음의 사업을 한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>연구논문 발표회 및 학술 강연회의 개최</li>
							<li>학회지, 학술간행물 및 도서의 간행</li>
							<li>산학협동을 위한 연구조사</li>
							<li>화장품 과학기술 발전에 기여한 업적 포상 및 학술활동 장려</li>
							<li>국제정보 교환 및 기술교류</li>
							<li>기타 본 학회의 목적달성에 필요한 사업</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '수혜평등 및 차별금지 원칙',
				body: (
					<S.RulesDescription>
						① 본 학회의 목적사업 등으로 발생한 수익은 공익을 위하여 사용하고, 회원 개인에게는 귀속시킬 수 없다.
						<br />② 본 학회의 수입은 학술의 발전과 공익을 위하여 사용하고 사업수행으로 제공하는 이익은 불특정다수인을 수혜자로 한다.
					</S.RulesDescription>
				),
			},
		],
	},
	{
		title: '회 원',
		articles: [
			{
				title: '회원의 자격과 종류',
				body: (
					<S.RulesDescription>
						① 본 학회의 회원은 본 학회의 설립취지와 제3조의 설립목적에 동의하고, 활동을 하고자 하는 자로서 소정의 입회원서를 제출하고 회비를 납부한자로 한다.
						<br />
						② 본 학회의 회원은 정회원, 일반회원, 학생회원, 명예회원 및 특별회원으로 구분한다.
						<br />
						③ 정회원은 대학, 연구기관, 기업 등에서 화장품과 관련된 연구, 생산⋅개발업무 등에 종사하고 있는 자로 소정의 연회비를 납부한 자로 한다.
						<br />
						④ 일반회원은 본 학회의 목적에 관련된 분야에 종사하고 있는 자로 화장품 과학에 관심있는 자로 한다.
						<br />
						⑤ 학생회원은 본 학회의 목적에 관련된 분야의 교육을 실시하고 있는 전문대학 이상의 학교에서 재학하고 있는 학생으로 한다.
						<br />
						⑥ 명예회원은 본 학회의 목적에 관하여 탁월한 공적이 있는 자 또는 본 학회의 발전에 크게 기여한 자로 한다.
						<br />⑦ 특별회원은 본 학회의 사업을 지원하기 위해서 국내·외의 단체 또는 법인으로 특별회비를 납부하는 자로 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '회원의 권리와 의무',
				body: (
					<S.RulesDescription>
						① 본 학회의 회원은 소정의 회비를 납부함으로써 정관 및 규정에 의한 권리와 의무를 갖는다.
						<br />
						② 모든 회원은 총회를 통하여 본 학회의 운영에 참여할 권리를 가진다. 다만 일반회원, 학생회원, 명예회원, 특별회원은 총회에 출석하여 발언 할 수 있으나
						의결권은 없으며, 선거권 및 피선거권은 정회원만이 갖는다.
						<br />
						③ 모든 회원은 총회 및 이사회의 결의를 준수해야 한다.
						<br />④ 본 학회의 정회원 자격은 연회비를 납부한 자로 하며, 정회원이 소정의 회비를 납부하지 않은 경우 회원자격이 정지되고, 자격정지 발효 후 연회비를
						납부하는 경우 정회원으로서의 자격이 회복된다. 단, 명예회원은 회비를 면제할 수 있다.
					</S.RulesDescription>
				),
			},
			{
				title: '회원의 제명 및 탈퇴',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>① 본 학회의 회원은 다음과 같은 사유가 있을 때 이사회의 의결을 거쳐 회장이 제명할 수 있다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>본 학회의 명예를 훼손시킨 자</li>
							<li>본 학회의 사업에 지장을 초래한 자</li>
							<li>본 학회의 제3조의 목적에 위배되는 행위를 한 자</li>
							<li>회비를 3년 이상 체납한 자</li>
						</S.DescriptionBox>
						<S.RulesDescription>
							② 회원이 본 학회를 탈퇴하고자 할 때에는 탈퇴서를 제출함으로써 자유롭게 탈퇴할 수 있다. 제명 및 탈퇴로 회원의 자격을 상실한 경우에는 납부한 회비
							등에 대한 반환권의 행사를 할 수 없다.
							<br />③ 위 제1항의 사유로 제명 처분을 받게 될 회원에 대하여 이사회는 당사자의 의견진술을 반드시 청취(구두 또는 서면)한 후 의결을 진행하여야 하며,
							당사자는 이사회에 출석하여 의견진술을 할 수 있다.
						</S.RulesDescription>
					</>
				),
			},
		],
	},
	{
		title: '임 원',
		articles: [
			{
				title: '임원의 종류와 정수',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>① 본 학회는 다음의 임원을 둔다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>회장 1인</li>
							<li>부회장 5인 내외(수석 부회장 포함)</li>
							<li>이사 5인 이상 15인 이내(회장 및 부회장을 포함한다.)</li>
							<li>집행이사 : 운영, 학술, 편집, 국제⋅홍보위원장, 산학협력위원장</li>
							<li>감사 2인 이내</li>
						</S.DescriptionBox>
						<S.RulesDescription>② 제1항 규정의 임원은 주무관청의 승인을 받아 그 수를 증감할 수 있다.</S.RulesDescription>
					</>
				),
			},
			{
				title: '임원의 임기',
				body: (
					<S.RulesDescription>
						① 임원의 임기는 2년으로 하되 연임 할 수 있다. 단, 회장의 임기는 2년으로 하되 2회까지 연임 할 수 있다.
						<br />
						② 임원의 임기 중 결원이 생길 때는 총회에서 보선하고, 보선된 임원의 임기는 전임자의 잔여기간으로 한다.
						<br />③ 임원의 임기의 개시는 회계연도 시작일로부터 시작하고, 차기 후임자의 취임 시까지로 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '임원의 선임',
				body: (
					<S.RulesDescription>
						① 회장은 전년도 (전임) 수석부회장이 자동으로 승계한다. 다만, 회장은 대표자의 명의로 공직선거법에 따른 선거운동을 한 사실이 없어야 한다.
						<br />
						② 이사는 정관 제18조의 결의 방법에 의하여 총회에서 선임한다.
						<br />
						③ 수석부회장은 이사 중에서 후보를 추천하여 이사회, 평의원회의 승인을 거쳐 총회의 승인을 받는다.
						<br />
						④ 감사는 회장이 후보를 추천하여 이사회 및 평의원회 승인을 거쳐 총회의 승인을 받는다.
						<br />
						⑤ 회장, 수석부회장, 감사의 취임 사실은 주무관청에 보고한다.
						<br />
						⑥ 임원의 보선은 결원이 발생한 날로부터 2월 이내에 하여야 한다.
						<br />⑦ 새로운 임원의 선출은 현직 임원의 임기만료 2월전까지 하여야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '임원의 해임',
				body: (
					<>
						<S.RulesDescription>임원이 다음 각호의 1에 해당하는 행위를 한 때에는 총회의 의결을 거쳐 해임할 수 있다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>본 학회의 목적에 위배되는 행위</li>
							<li>임원간의 분쟁⋅회계부정 또는 현저한 부당행위</li>
							<li>본 학회의 업무를 방해하는 행위</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '임원의 선임 제한',
				body: (
					<S.RulesDescription>
						① 임원의 선임에 있어서 이사는 이사 상호간에 민법 제777조 및 공익법인의 설립 운영에 관한 법률 시행령 제12조의 규정에 의한 특수관계에 해당하는 이사의
						수는 이사정수의 1/5을 초과할 수 없다.
						<br />② 감사는 감사 상호간 또는 이사(회장을 포함한다.)와 제1항에 규정한 민법 제777조 및 특수관계에 해당하는 자가 아니어야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '임원의 결격사유 및 자격 상실',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>① 다음 각 호의 어느 하나에 해당하는 자는 임원이 될 수 없다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>미성년자, 피성년후견인 또는 피한정후견인</li>
							<li>파산자로서 복권이 되지 아니한 자</li>
							<li>법원의 판결 또는 다른 것에 의하여 자격이 상실 또는 정지된 자</li>
							<li>
								금고 이상의 실형을 선고를 받고 그 집행이 종료(집행이 종료된 것으로 보는 경우를 포함한다)되거나 집행이 면제된 날부터 3년이 지나지 아니한 자
							</li>
							<li>금고 이상의 형의 집행유예선고를 받고 그 유예기간 중에 있는 자</li>
						</S.DescriptionBox>
						<S.RulesDescription>② 다음 각 호의 사유가 있는 임원은 즉시 그 자격을 상실한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>본회를 탈퇴한 자</li>
							<li>금고 이상의 실형이 확정된 자</li>
							<li>
								다음 각 호의 사유가 있는 임원은 이사회의 의결을 거쳐 해임할 수 있고, 주무관청에게 보고하여야 한다.
								<br />
								가. 제8조(회원의 제명 및 탈퇴)의 각 규정에 해당하는 자<br />
								나. 임원의 임기 중 1년 이상 임원으로서의 의무를 게을리한 자
							</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '임원의 직무',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>
							① 회장은 본회를 대표하고 본회의 업무를 총괄하며, 총회 및 이사회, 평의원회의 의장이 된다.
							<br />
							② 수석부회장은 회장을 보좌한다.
							<br />
							③ 회장의 유고로 회장이 직무를 수행할 수 없을 때에는 수석부회장이 그 직무를 대행한다.
							<br />
							④ 이사는 이사회에 출석하여 본 학회의 업무에 관한 사항을 의결하며 이사회 또는 회장으로부터 위임받은 사항을 처리한다.
							<br />⑤ 감사는 다음 직무를 수행한다.
						</S.RulesDescription>
						<S.DescriptionBox>
							<li>본 학회의 재산상황을 감사하는 일</li>
							<li>총회 및 이사회의 운영과 그 업무에 관한 사항을 감사하는 일</li>
							<li>제1호 및 제2호의 감사결과, 부정 또는 부당한 점이 있음을 발견한 때에는 이사회 또는 총회에 그 시정을 요구하고 주무관청에 보고하는 일</li>
							<li>제3호의 시정요구 및 보고를 하기 위하여 필요한 때에는 총회 또는 이사회의 소집을 요구하는 일</li>
							<li>본 학회의 재산상황과 업무에 관하여 총회 및 이사회 또는 회장에게 의견을 진술하는 일</li>
							<li>총회 및 이사회의 회의록에 기명날인하는 일</li>
						</S.DescriptionBox>
					</>
				),
			},
		],
	},
	{
		title: '총 회',
		articles: [
			{
				title: '총회의 구성',
				body: <S.RulesDescription>총회는 본 학회의 최고의결기관이며 정회원으로 구성한다.</S.RulesDescription>,
			},
			{
				title: '구분 및 소집',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>
							① 총회는 정기총회와 임시총회로 구분하며, 회장이 이를 소집한다.
							<br />
							② 정기총회는 매 회계연도 개시 1월 전까지 소집하며, 총회의 소집은 회장이 회의안건⋅일시⋅장소 등을 명기하여 회의 개시 7일전까지 문서(SNS, 문자,
							전자문서 포함)로 각 회원에게 통지하여야 한다.
							<br />③ 임시총회는 다음의 경우에 회장이 소집한다.
						</S.RulesDescription>
						<S.DescriptionBox>
							<li>회장이 필요하다고 인정할 때</li>
							<li>이사회의 의결로 요구할 때</li>
							<li>정회원 총수의 5분의 1 이상이 요구할 때</li>
							<li>감사가 소집을 요구할 때</li>
						</S.DescriptionBox>
						<S.RulesDescription>④ 총회는 제②항의 통지사항에 한하여서만 의결할 수 있다.</S.RulesDescription>
					</>
				),
			},
			{
				title: '의결정족수',
				body: (
					<S.RulesDescription>
						① 총회는 회비를 성실히 납부한 정회원 5분의 1의 출석으로 개의하고 출석회원 과반수의 찬성으로 의결한다.
						<br />
						② 회원의 의결권은 총회에 참석하는 다른 회원에게 서면으로 위임할 수 있다. 이 경우 위임장은 총회 개시 전까지 의장에게 제출하여야 한다.
						<br />③ 총회의 의결사항은 의사록에 기록하여 보관하여야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '총회의 기능',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>총회는 다음의 사항을 의결한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>임원 선출 및 해임에 관한 사항</li>
							<li>정관변경에 관한 사항</li>
							<li>예산 및 결산의 승인에 관한 사항</li>
							<li>사업계획의 승인에 관한 사항</li>
							<li>법인 해산에 관한 사항</li>
							<li>기타 이사회 의결사항의 승인 등 회무 운영에 관한 중요사항</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '총회의결 제척사유',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>회원이 다음 각호의 1에 해당하는 때에는 그 의결에 참여하지 못한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>임원의 선출 및 해임에 있어 자신에 관한 사항을 의결할 때</li>
							<li>금전 및 재산의 수수 또는 소송 등에 관련되는 사항으로서 자신과 본 학회의 이해가 상반될 때</li>
						</S.DescriptionBox>
					</>
				),
			},
		],
	},
	{
		title: '평의원회',
		articles: [
			{
				title: '평의원회 설치',
				body: <S.RulesDescription>본 학회의 원활한 제반 운영을 위하여 평의원회를 둔다.</S.RulesDescription>,
			},
			{
				title: '평의원회의 기능',
				body: (
					<>
						<S.RulesDescription>평의원회는 다음 사항을 수행한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>수석부회장의 승인에 관한 사항</li>
							<li>이사회가 위임하는 사항</li>
							<li>기타 본회 운영에 관한 자문</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '평의원회의 구성 및 평의원의 선출',
				body: (
					<S.RulesDescription>
						① 평의원회는 평의원으로 구성하며 평의원회 의장은 본 학회 회장으로 한다.
						<br />② 평의원은 연회비를 납부한 정회원 중 이사가 아닌 자 중 이사회 추천을 거쳐 회장이 임명한 자로 구성한다.
					</S.RulesDescription>
				),
			},
			{
				title: '평의원의 임기',
				body: <S.RulesDescription>평의원의 임기는 1년으로 하며 연임할 수 있다.</S.RulesDescription>,
			},
			{
				title: '평의원회의 소집과 의결 정족수',
				body: (
					<S.RulesDescription>
						① 정기 평의원회 회의는 년 1회 소집한다. 단, 필요에 따라 의장이 회의의 심의안건을 발송하여 임시 평의원회를 소집할 수 있다.
						<br />② 평의원회는 출석한 평의원 과반수의 찬성으로 의결하며 가부동수인 경우에는 의장이 결정한다.
					</S.RulesDescription>
				),
			},
			{
				title: '기타',
				body: <S.RulesDescription>본 장에 규정되지 아니한 사항은 이사회의 의결에 따른다.</S.RulesDescription>,
			},
		],
	},
	{
		title: '이사회',
		articles: [
			{
				title: '이사회의 구성',
				body: <S.RulesDescription>이사회는 회장과 수석부회장, 이사로 구성한다.</S.RulesDescription>,
			},
			{
				title: '구분 및 소집',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>
							① 이사회는 정기이사회와 임시이사회로 구분하며, 회장이 이를 소집한다.
							<br />
							② 정기이사회는 매 회계연도 정기총회에 상정할 안건 및 의결사항을 위해 정기총회 이전으로 소집하며, 임시이사회는 회장이 필요하다고 인정할 때에
							소집한다.
							<br />③ 임시이사회는 다음의 경우에 회장이 소집한다.
						</S.RulesDescription>
						<S.DescriptionBox>
							<li>회장이 필요하다고 인정할 때</li>
							<li>재적이사 과반수가 회의의 목적을 제시하여 소집을 요구한 때</li>
							<li>제12조 제4항 제4호의 규정에 의하여 감사가 소집을 요구한 때</li>
							<li>
								이사회의 소집권자가 궐위 되었거나 또는 이를 기피함으로써 7일 이상 이사회의 소집이 불가능한 때에는 재적이사 과반수의 찬성을 받아 주무관청의
								승인을 얻어 이를 소집할 수 있다.
							</li>
						</S.DescriptionBox>
						<S.RulesDescription>
							④ 이사회의 소집은 회장이 회의안건⋅일시⋅장소 등을 명기하여 회의 개시 7일전까지 문서(SNS, 문자, 전자문서 포함)로 각 이사 및 감사에게 통지하여야
							한다.
							<br />⑤ 이사회는 제4항의 통지사항에 한해서만 의결할 수 있다. 다만 재적이사 전원이 출석하고 출석이사 및 감사 전원이 찬성할 때에는 통지하지 아니한
							사항이라도 이를 부의하고 의결할 수 있다.
						</S.RulesDescription>
					</>
				),
			},
			{
				title: '의결정족수',
				body: (
					<S.RulesDescription>
						① 이사회는 재적이사 과반수의 출석으로 개의하고 출석이사 과반수의 찬성으로 의결한다.
						<br />
						② 이사회의 의결사항 중 이사 자신에 관한 사항이나 금전 또는 재산의 수수를 수반하는 사항으로써 이사 자신과 본 학회의 이해가 상반되는 사항의 경우 그
						이사는 이사회의 의결에 참여하지 못한다.
						<br />③ 이사회의 이사는 서면으로 의결권을 행사할 수 있다. 이 경우에 회장은 그 결과를 차기 이사회에 보고하여야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '이사회의 의결사항',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>이사회는 다음의 사항을 심의⋅의결한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>사업계획의 수립, 예산편성 및 결산에 관한 사항</li>
							<li>재산의 변경에 관한 사항</li>
							<li>총회에서 위임받은 사항 및 총회에 제출하여 승인을 요하는 사항</li>
							<li>수석부회장, 감사 추천 및 보선에 관한 사항</li>
							<li>평의원 추천에 관한 사항</li>
							<li>정관개정안에 관한 사항, 제규칙 제정에 관한 사항</li>
							<li>회비에 관한 사항</li>
							<li>포상에 관한 사항</li>
							<li>정관에 의하여 그 권한에 속하는 사항</li>
							<li>위원회의 설치에 관한 사항</li>
							<li>기타 본 학회의 운영상 중요하다고 인정하여 회장이 부의하는 사항</li>
						</S.DescriptionBox>
					</>
				),
			},
		],
	},
	{
		title: '위원회',
		articles: [
			{
				title: '위원회',
				body: (
					<S.RulesDescription>
						① 본 학회의 업무를 효율적으로 관장하기 위하여 운영위원회, 학술위원회, 편집위원회, 산학협력위원회 등을 둔다.
						<br />
						② 운영위원회에서는 기획⋅재무⋅사무 등의 업무를 추진한다.
						<br />
						③ 학술위원회에서는 학술활동을 지원하며 원활한 학술활동을 위하여 이사회의 심의⋅의결을 거쳐 분과위원회를 둘 수 있다.
						<br />
						④ 편집위원회는 대한화장품학회지 및 심포지엄 프로시딩의 편집업무를 지원한다.
						<br />
						⑤ 산학협력위원회는 국내⋅외 유관 학회 협력, 회원, 전시부스 등의 유치업무를 추진한다.
						<br />⑥ 각 위원회는 약간 명의 위원을 둘 수 있으며, 위원회의 설치 및 사항은 별도 규정에 따라 정한다.
					</S.RulesDescription>
				),
			},
		],
	},
	{
		title: '재산과 회계',
		articles: [
			{
				title: '재산의 구분',
				body: (
					<S.RulesDescription>
						① 본 학회의 재산은 기본재산과 보통재산으로 구분한다.
						<br />
						② 기본재산은 본 학회 설립 시 부동산 등으로 하고 그 목록은 “별지1”로 한다.
						<br />③ 보통재산은 기본재산 이외의 재산으로 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '재산의 처분',
				body: (
					<S.RulesDescription>
						① 본 학회의 기본재산을 매도, 증여, 임대 등 처분행위는 이사회의 의결을 거쳐 총회의 승인을 받은 다음 주무관청의 승인을 받아야 한다.
						<br />② 기본 재산의 처분에 관하여는 정관 제44조 정관변경에 관한 규정을 준용한다.
					</S.RulesDescription>
				),
			},
			{
				title: '수입금',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>본 학회의 유지 및 운영에 필요한 경비의 재정은 다음의 수입금으로 충당한다.</S.RulesDescription>
						<S.DescriptionBox>
							<li>회원의 회비 및 입회금</li>
							<li>재산으로 생기는 과실</li>
							<li>사업에 따른 수입</li>
							<li>각종 기부금</li>
							<li>기타 수입금</li>
						</S.DescriptionBox>
					</>
				),
			},
			{
				title: '회계연도',
				body: <S.RulesDescription>본 학회의 회계연도는 정부의 회계 연도에 따른다.</S.RulesDescription>,
			},
			{
				title: '예산편성',
				body: (
					<S.RulesDescription>
						본 학회의 는 매 회계연도 개시 1월전까지 사업계획서와 수입 · 지출예산을 편성하여, 이사회의 의결을 거쳐 총회의 승인을 얻어 정한다.
					</S.RulesDescription>
				),
			},
			{
				title: '결산',
				body: (
					<S.RulesDescription>
						해당 사업연도의 사업실적 및 수입·지출 결산서는 이사회의 의결을 거쳐 해당 회계년도 종료후 2개월 이내에 주무관청에 보고하고 차기 총회에 보고 및 승인을
						받는 것으로 한다. 이 경우 재산목록과 업무현황 및 감사결과 보고서도 함께 제출하여야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '분배금지',
				body: (
					<S.RulesDescription>본 학회는 비영리법인으로서 제34조 수입금 등에 관하여 어떠한 명목으로도 구성원 간 분배를 허용하지 아니한다.</S.RulesDescription>
				),
			},
			{
				title: '기부금활용실적 공개',
				body: (
					<S.RulesDescription>
						본 학회는 인터넷에 홈페이지를 개설하고 인터넷 홈페이지와 국세청 홈페이지에 연간 기부금 모금액 및 활용실적을 매년 4월 30일까지 공개한다.
					</S.RulesDescription>
				),
			},
			{
				title: '업무보고',
				body: <S.RulesDescription>다음 연도의 사업계획서 및 예산서는 회계연도 종료 후 2개월 이내에 주무관청에 보고하여야 한다.</S.RulesDescription>,
			},
			{
				title: '회계감사',
				body: <S.RulesDescription>감사는 회계감사를 년 1회 이상 실시하여야 한다.</S.RulesDescription>,
			},
			{
				title: '임원의 보수',
				body: <S.RulesDescription>임원에 대하여는 보수를 지급하지 아니한다. 다만, 업무수행에 필요한 실비는 지급할 수 있다.</S.RulesDescription>,
			},
		],
	},
	{
		title: '사무부서',
		articles: [
			{
				title: '사무국',
				isBox: true,
				body: (
					<>
						<S.RulesDescription>
							① 회장의 지시를 받아 본 학회의 사무를 처리하기 위하여 사무국을 둔다.
							<br />
							② 사무국에 사무국장 1인과 필요한 직원을 둘 수 있다.
							<br />③ 사무국은 다음 각 호의 사업을 계획하고 추진한다.
						</S.RulesDescription>
						<S.DescriptionBox>
							<li>본 학회의 학술활동 전반에 관한 행정 사항</li>
							<li>본 학회의 예산 및 결산, 자산관리에 관한 행정 사항</li>
							<li>회원관리 등 기타 본 학회 운영에 관한 사항</li>
							<li>총회 및 평의원회, 이사회 등 회의준비에 관한 행정 사항</li>
							<li>학회 발간 학술지 발간에 관한 행정 사항</li>
						</S.DescriptionBox>
						<S.RulesDescription>
							④ 사무국장은 이사회의 의결을 거쳐 회장이 임면한다.
							<br />⑤ 사무국의 조직 및 운영에 관한 사항은 이사회의 의결을 거쳐 별도로 정한다.
						</S.RulesDescription>
					</>
				),
			},
		],
	},
	{
		title: '보 칙',
		articles: [
			{
				title: '정관변경',
				body: (
					<S.RulesDescription>
						본 학회의 정관을 변경하고자 할 때에는 재적 정회원 3분의 2이상의 찬성과 총회의 의결을 거쳐 주무관청의 허가를 받아야 한다.
					</S.RulesDescription>
				),
			},
			{
				title: '법인해산',
				body: (
					<S.RulesDescription>
						① 본 학회가 해산하고자 할 때에는 총회에서 정회원 3분의 2이상의 찬성으로 의결하여 해산하고, 그 해산에 관하여 주무관청에 신고하여야 한다.
						<br />② 본 학회가 해산한 때의 잔여재산은 총회의 의결을 거쳐 주무관청의 승인을 얻은 후 국가, 지방자치단체 또는 본 학회와 유사한 목적을 가진 다른
						비영리법인에게 귀속한다.
					</S.RulesDescription>
				),
			},
			{
				title: '규칙 제정',
				body: <S.RulesDescription>이 정관에 정한 것 외에 본 학회의 운영에 관하여 필요한 사항은 이사회의 의결을 거쳐 규칙으로 정한다.</S.RulesDescription>,
			},
			{
				title: '청산',
				body: (
					<S.RulesDescription>
						① 학회가 해산할 때에는 회장이 청산인이 된다. 다만, 총회의 의결을 거쳐 회원 중에서 청산인을 선임하는 경우에는 그러하지 아니한다.
						<br />
						② 청산인은 취임 시 지체없이 재산상황을 조사하고 재산목록과 대차대조표를 작성하여 이사회에 보고하고 이를 회원에게 공개하여야한다.
						<br />
						③ 학회가 해산할 때에는 학회내의 채무를 결제한다.
						<br />④ 청산에 관하여 이 정관에 정하지 아니한 그 밖의 사항은 민법 중 사단법인의 청산에 관한 규정을 따른다.
					</S.RulesDescription>
				),
			},
			{
				title: '준용규정',
				body: (
					<S.RulesDescription>
						이 정관에 규정되지 아니한 사항은 민법 중 사단법인에 관한 규정과 식품의약품안전처 소관 비영리법인의 설립 및 감독에 관한 규칙 및 비송사건절차법을
						준용한다.
					</S.RulesDescription>
				),
			},
		],
	},
	{
		title: '부 칙',
		isNumbered: false,
		articles: [
			{
				title: '시행일',
				body: <S.RulesDescription>이 정관은 주무관청의 허가를 받아 법원에 등기한 날로부터 시행한다.</S.RulesDescription>,
			},
			{
				title: '경과조치',
				body: <S.RulesDescription>이 정관 시행당시 법인 설립을 위하여 발기인 등이 행한 행위는 이 정관에 의하여 행한 것으로 본다.</S.RulesDescription>,
			},
			{
				title: '설립당시의 회원 및 임원 등',
				body: (
					<S.RulesDescription>
						① 본 학회의 설립 당시의 대한화장품학회 정회원은 본 학회의 정회원으로 본다.
						<br />
						② 본 학회의 설립당시 이사 및 감사는 본 정관에 의하여 선출된 것으로 본다. 설립당시 이사 및 감사의 임기는 본 정관의 규정에 의한다.
						<br />③ 본 학회의 설립당시 대한화장품학회의 이사 등 임원으로서 본 학회 설립당시의 이사 및 감사가 아닌 자는 본 학회 준이사로 본다.
					</S.RulesDescription>
				),
			},
			{
				title: '설립자의 기명날인',
				body: <S.RulesDescription>본 학회를 설립하기 위하여 이 정관을 작성하고 다음과 같이 설립자 전원이 기명 날인한다.</S.RulesDescription>,
			},
		],
	},
	{
		title: '부 칙',
		isNumbered: false,
		articles: [
			{
				title: '시행일',
				body: <S.RulesDescription>이 정관은 주무관청의 인가(2026년01월14일, 식품의약품안전처 화장품정잭과-323) 를 받은 날로부터 시행한다.</S.RulesDescription>,
			},
		],
	},
];

const Rules = () => {
	const [category, setCategory] = useState('정관');
	const categoryList = ['정관', '투고규정'];
	const useContinuousArticleNumbering = true;

	const onClickTabBar = (tab: string) => {
		setCategory(tab);
	};

	let numberedChapterCount = 0;
	let articleCount = 0;

	const numberedChapters = charterChapters.map((chapter) => {
		const isChapterNumbered = chapter.isNumbered !== false; // 부칙 제외
		const chapterNumber = isChapterNumbered ? (numberedChapterCount += 1) : null;
		const articleNumberBase = useContinuousArticleNumbering && isChapterNumbered ? articleCount : 0;

		const articles = chapter.articles.map((article, articleIndex) => ({
			...article,
			number: articleNumberBase + articleIndex + 1,
		}));

		if (useContinuousArticleNumbering && isChapterNumbered) {
			articleCount += chapter.articles.length;
		}

		return {
			...chapter,
			articles,
			chapterNumber,
		};
	});

	return (
		<S.RulesWrapper>
			<S.RulesCategoryList>
				{categoryList.map((c) => (
					<S.RulesCategory key={c} className={c === category ? 'active' : ''} onClick={() => onClickTabBar(c)}>
						{c}
					</S.RulesCategory>
				))}
			</S.RulesCategoryList>

			{category === '정관' && (
				<S.RulesContainer>
					<S.RulesHistory>
						<p>(개정 2021년 3월 2일)</p>
						<p>(개정 2025년 11월 21일)</p>
					</S.RulesHistory>
					{numberedChapters.map((chapter, chapterIndex) => (
						<S.RulesContent key={`${chapter.title}-${chapterIndex}`}>
							<S.RulesTitle>{chapter.chapterNumber ? `제 ${chapter.chapterNumber}장 ${chapter.title}` : chapter.title}</S.RulesTitle>
							{chapter.articles.map((article) => {
								const Wrapper = article.isBox ? S.RulesContentItemBox : S.RulesContentItem;

								return (
									<Wrapper key={`${chapter.title}-${article.title}-${article.number}`}>
										<S.RulesSubTitle>
											제{article.number}조({article.title})
										</S.RulesSubTitle>
										{article.body}
									</Wrapper>
								);
							})}
						</S.RulesContent>
					))}
					<S.RulesTableSection>
						<p>[별지 1] 기본재산목록</p>
						<S.RulesTableScroll>
							<S.RulesTable>
								<colgroup>
									<col style={{ width: '12%' }} />
									<col style={{ width: '14%' }} />
									<col style={{ width: '30%' }} />
									<col style={{ width: '14%' }} />
									<col style={{ width: '18%' }} />
									<col style={{ width: '12%' }} />
								</colgroup>
								<thead>
									<tr>
										<th />
										<th>구 분</th>
										<th>내용/소재지</th>
										<th>
											수량/면적
											<br />
											(m²)
										</th>
										<th>
											평가액
											<br />
											(원)
										</th>
										<th>비고</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td rowSpan={2}>기본재산</td>
										<td>건 물</td>
										<td rowSpan={2}>
											서울시 송파구 법원로 127,
											<br />
											316호
										</td>
										<td>71.52</td>
										<td rowSpan={2}>644,000,000</td>
										<td rowSpan={2}>
											부동산
											<br />
											고유번호
											<br />
											2442-2016-003471
										</td>
									</tr>
									<tr>
										<td>토 지</td>
										<td>15.09</td>
									</tr>
									<tr className="total-row">
										<td />
										<td>총 계</td>
										<td />
										<td />
										<td>644,000,000</td>
										<td />
									</tr>
								</tbody>
							</S.RulesTable>
						</S.RulesTableScroll>
					</S.RulesTableSection>
				</S.RulesContainer>
			)}
			{category === '투고규정' && (
				<S.RulesContainer>
					<S.RulesHistory>
						<p>(시행 2021년 3월 2일)</p>
						<p>(개정 2026년 2월 25일)</p>
					</S.RulesHistory>
					<S.RulesSubmissionContainer>
						<S.RulesSubTitle>｢대한화장품학회지｣ 논문투고규정</S.RulesSubTitle>
						<S.RulesSubmissionDescriptionBox>
							{submissionRules.map((rule, index) => (
								<li key={`submission-rule-${index + 1}`}>{rule}</li>
							))}
						</S.RulesSubmissionDescriptionBox>
					</S.RulesSubmissionContainer>
				</S.RulesContainer>
			)}
		</S.RulesWrapper>
	);
};

export default Rules;
